export function validateEmail(email?: string) {
  if (!email) return false;

  return /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
}
